import scrollbar from '~/js/libs/jquery.scrollbar';

const roomsFilter = () => {
    let filterList = $('.js-scroll-list');
    let roomsFilter = $('.js-rooms-filter');
    let roomsFilterClose = $('.js-rf-close');
    let roomsFilterShow = $('.js-show-filter');
    let roomsFilterReset = $('.js-rooms-filter-reset');
    let checkbox = roomsFilter.find('input[type=checkbox]');
    let scrollTop;

    function scrollLock() {
        $(window).on('scroll touchmove mousewheel', function (e) {
            $(window).scrollTop(scrollTop);
        });
    }

    function scrollUnlock() {
        $(window).off('scroll touchmove mousewheel');
    }

    filterList.scrollbar({
        scrollStep: 20
    });

    roomsFilterShow.on('click', function(e) {
        e.preventDefault();

        roomsFilter.addClass('rooms-filter--open');
        scrollTop = $(window).scrollTop();
        scrollLock();
    });

    roomsFilterClose.on('click', function(e) {
        e.preventDefault();

        roomsFilter.removeClass('rooms-filter--open');
        scrollUnlock();
    });

    // roomsFilterReset.on('click', function(e) {
    //     e.preventDefault();

    //     checkbox.each(function() {
    //         this.checked = false;
    //     });
    // });
}

export default roomsFilter;